import _ from 'lodash';
import { getValues } from 'redux-form';
import { fork, put, select, take, takeLatest } from 'redux-saga/effects';

import {
    EDIT_GUARANTOR,
    EDITING_GUARANTOR,
    EDIT_GUARANTOR_LEAVE
} from './AdditionalGuarantor.actions';
import { buildApplicationState } from '../../helpers/applicationManager';
import { OPEN_MODAL, CLOSE_MODAL } from '../Modals/Modals.actions';

function* additionalGuarantorSaga() {
    yield takeLatest(EDIT_GUARANTOR, function* ({ uid }) {
        const guarantors = yield* getGuarantors();

        yield put({
            type: EDITING_GUARANTOR,
            uid,
            guarantors
        });

        yield put({
            type: OPEN_MODAL,
            modalId: 'additionalGuarantor'
        });

        yield take(CLOSE_MODAL);
        yield put({
            type: EDIT_GUARANTOR_LEAVE
        });
    });
}

export function* getGuarantors() {
    const applicationState = yield* getApplicationState();
    return _.filter(applicationState.people, (person) => {
        return (
            _.includes(person.roles, 'guarantor') &&
            !_.includes(person.roles, 'applicant')
        );
    });
}

function* getApplicationState() {
    const { application, formValues } = yield select((state) => ({
        application: state.fetched.application.payload,
        formValues: getValues(state.form.sign_up)
    }));

    return buildApplicationState(application, formValues);
}

export default [fork(additionalGuarantorSaga)];
